// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.T2_4Wynpn9w4B1mqwI4s{padding:16px 0}.EubzdjlEkc3Q7lgz0k0k{height:calc(100vh - 450px)}.fvEtwn8ngtl5Dl62tCyg{border-bottom:1px solid var(--border-neutral-default)}.GY1gjU7lVZM9P2w7ZZuc{border-bottom:1px solid var(--border-neutral-default);display:flex}.S3TPD7c2Qf0aIt3apRGX{flex-direction:column;justify-content:center}.v0W_2x2TBQQShCd6q59W{white-space:initial;margin-bottom:0;padding:16px 8px}.o4iZTnHNr4hCf8WmPs9s{margin-bottom:6px;line-height:16px}.o4iZTnHNr4hCf8WmPs9s:last-child{margin-bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `T2_4Wynpn9w4B1mqwI4s`,
	"bodyContainer": `EubzdjlEkc3Q7lgz0k0k`,
	"header": `fvEtwn8ngtl5Dl62tCyg`,
	"row": `GY1gjU7lVZM9P2w7ZZuc`,
	"columnHeaderCell": `S3TPD7c2Qf0aIt3apRGX`,
	"previewCell": `v0W_2x2TBQQShCd6q59W`,
	"previewCellValue": `o4iZTnHNr4hCf8WmPs9s`
};
export default ___CSS_LOADER_EXPORT___;
